import React, {Fragment} from "react";
import {PageHeader} from "./PageHeader";
import content from "../content/resources.json";
import {useContent} from "../customHooks/useContent";

export const Resources = () => {
    const text = useContent(content);

    return (
        <Fragment>
            <PageHeader subtitle={text.subtitle} imageClass="header-resources"/>
            <main className="resources">
                <div className="container">
                    <div className="row">
                        <section className="col-12">
                            <ul>
                                <li><a href="http://www.anthropology.uw.edu.pl/">Bioarchaeology of the Near East ({text.all_volumes})</a></li>
                                <li><a href="http://www.antropologia.uw.edu.pl/SHA/default.html"> Studies in Historical
                                    Anthropology ({text.volumes} 1-4)</a></li>
                                <li><a href="http://www.antropologia.uw.edu.pl/AR/default.html">Antropologia Religii
                                    ({text.volumes} 1-5)</a></li>
                                <li><a href="http://www.antropologia.uw.edu.pl/MaCzek/maczek.html">MaCzek, {text.version} 3.3</a></li>
                                <li><a href="https://www.archeologia.uw.edu.pl">Instytut Archeologii UW</a></li>
                            </ul>
                            <span className="bold">{text.dr_hab} Arkadiusz Sołtysiak{text.prof}</span>
                            <ul>
                                <li><a href="https://uw.academia.edu/ArkadiuszSo%C5%82tysiak">Academia</a></li>
                                <li><a href="https://www.researchgate.net/profile/Arkadiusz_Soltysiak">ResearchGate</a>
                                </li>
                                <li><a href="https://scholar.google.pl/citations?user=PqB4Tl0AAAAJ&hl=pl">Google
                                    Scholar</a></li>
                            </ul>
                            <span className="bold">{text.dr} Rafał Fetner</span>
                            <ul>
                                <li><a href="https://uw.academia.edu/Rafa%C5%82Fetner">Academia</a></li>
                                <li><a href="https://www.researchgate.net/profile/Rafal_Fetner">ResearchGate</a></li>
                                <li><a href="https://scholar.google.com/citations?user=oIMJFiEAAAAJ&hl=ja">Google
                                    Scholar</a></li>
                            </ul>
                            <span className="bold">Joanna Trębicka</span>
                            <ul>
                                <li><a href="https://uw.academia.edu/JoannaTrebicka">Academia</a></li>
                                <li><a href="https://www.researchgate.net/profile/Joanna_Trebicka">ResearchGate</a></li>
                            </ul>
                        </section>
                    </div>
                </div>
            </main>
        </Fragment>
    )
};
